<template>
  <span v-bind="$attrs" class="inline-pill">{{ content }}</span>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    content?: string;
  }>(),
  {},
);
</script>

<style scoped>
.inline-pill {
  /* Crucial properties for the inline pill effect */
  display: inline-block; /* Sits inline but respects padding/height */
  border-radius: 9999px; /* Keeps the edges perfectly rounded */
  padding: 4px 12px; /* Vertical and horizontal space inside the pill */

  /* Styling details */
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap; /* Prevents the pill text from wrapping */

  /* Default Colors */
  background-color: #e2e8f0;
  color: #475569;
  padding: 8px 16px;
}

/* Optional variation example */
/* Pending/Warning State (Yellow/Orange) */
.pill-pending {
  background-color: #fef7e0;
  color: #b06000;
  border-color: #feefc3;
}

.pill-blue {
  background-color: #dbeafe;
  color: #1d4ed8;
}

.pill-gray {
  background-color: #eee;
  color: #000000;
}

.pill-black {
  background-color: #ffffff;
  color: #000;
}

.pill-red {
  background-color: #fce8e6;
  color: #c5221f;
  border-color: #fad2cf;
}
</style>
